<app-admin-list-page [title]="'Education levels' | translate">

  <button slot="actions" class="btn btn-primary" (click)="addEducationLevel()">
    {{'Add' | translate}}
  </button>

  <app-table [config]="configTable" (buttonEvent)="handleButtonEvent($event)"></app-table>

</app-admin-list-page>
